module.exports = __webpack_public_path__ + "img/Verona.98b17280.png";